// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * DetailView - Odoo-style full-screen record form — DARK INDIGO THEME
 * Covers the main content area (right of sidebar, below navbar)
 * Sidebar (240px) and Navbar (--app-topbar-h) remain visible and fixed.
 */

/* ── Overlay ── */
.dv-overlay {
  position: fixed;
  top: calc(var(--app-topbar-h, 69px) + var(--app-crumb-h, 42px));
  left: 240px;
  right: 0;
  bottom: 0;
  background: var(--slate-50);
  z-index: 500;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media (max-width: 992px) {
  .dv-overlay {
    left: 0;
  }
}

/* ── Top action bar ── */
.dv-topbar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 1.25rem;
  height: 48px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
}

.dv-back-btn {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  transition: all 0.15s;
  white-space: nowrap;
}
.dv-back-btn:hover { background: var(--bg-toolbar); color: var(--text-primary); }
.dv-back-btn svg { width: 16px; height: 16px; }

.dv-topbar-sep {
  width: 1px;
  height: 20px;
  background: var(--border);
  flex-shrink: 0;
}

/* Contador de fichas: ‹ 3 / 27 › */
.dv-pager {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  padding-left: 0.75rem;
  margin-left: 0.25rem;
  border-left: 1px solid var(--border);
}

.dv-pager-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  background: none;
  border: 1px solid transparent;
  border-radius: 7px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.dv-pager-btn svg { width: 16px; height: 16px; }

.dv-pager-btn:hover:not(:disabled) {
  background: var(--bg-toolbar);
  border-color: var(--border);
  color: var(--text-primary);
}

.dv-pager-btn:disabled { opacity: 0.35; cursor: default; }

.dv-pager-count {
  min-width: 4.5ch;
  text-align: center;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.dv-breadcrumb {
  font-size: 0.8rem;
  color: var(--text-muted);
  white-space: nowrap;
}
.dv-breadcrumb-current {
  color: var(--text-primary);
  font-weight: 600;
}

.dv-topbar-spacer { flex: 1 1; }

.dv-topbar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dv-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.85rem;
  border-radius: 5px;
  font-size: 0.82rem;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  text-decoration: none;
}
.dv-btn svg { width: 14px; height: 14px; }

.dv-btn-primary {
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: #fff;
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(var(--accent-rgb),.35);
}
.dv-btn-primary:hover { background: linear-gradient(135deg, var(--accent-l), var(--accent)); box-shadow: 0 4px 12px rgba(var(--accent-rgb),.45); transform: translateY(-1px); }
.dv-btn-primary:disabled { opacity: 0.5; cursor: default; transform: none; }

.dv-btn-secondary {
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  border-color: var(--border);
}
.dv-btn-secondary:hover { background: var(--slate-200); color: var(--text-primary); }

.dv-btn-danger {
  background: rgba(220,38,38,.12);
  color: #f87171;
  border-color: rgba(220,38,38,.25);
}
.dv-btn-danger:hover { background: rgba(220,38,38,.2); }

.dv-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.65rem;
  border-radius: 99px;
  font-size: 0.75rem;
  font-weight: 600;
}
.dv-status-active { background: rgba(16,185,129,.15); color: #6ee7b7; border: 1px solid rgba(16,185,129,.25); }
.dv-status-inactive { background: rgba(220,38,38,.12); color: #f87171; border: 1px solid rgba(220,38,38,.2); }

/* ── SmartButtons bar ── */
.dv-smartbar {
  display: flex;
  align-items: center;
  gap: 0;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  overflow-x: auto;
  padding: 0 1rem;
}

.dv-smart-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1.25rem;
  border: none;
  border-right: 1px solid var(--border);
  background: transparent;
  cursor: pointer;
  transition: background 0.15s;
  min-width: 90px;
  gap: 0.15rem;
}
.dv-smart-btn:first-child { border-left: 1px solid var(--border); }
.dv-smart-btn:hover { background: rgba(var(--accent-rgb),.08); }

.dv-smart-btn-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--accent-l);
  line-height: 1;
}
.dv-smart-btn-label {
  font-size: 0.68rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.dv-smart-btn-icon {
  font-size: 1rem;
  margin-bottom: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-l);
}
.dv-smart-btn-icon svg {
  width: 18px !important;
  height: 18px !important;
  flex-shrink: 0;
  stroke: currentColor !important;
  fill: none !important;
}

/* ── Body (tabs + sidebar) ── */
.dv-body {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

/* ── Main panel ── */
.dv-main {
  flex: 1 1;
  /* \`min-width: 0\` es obligatorio: sin él, un \`flex: 1\` no baja de su contenido
     mínimo y el formulario empujaba el panel de actividad fuera de la ficha
     (se veía solo una franja del panel en el borde derecho). */
  min-width: 0;
  overflow-y: auto;
  padding: 1.5rem 2rem;
  background: var(--slate-50);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

/* Modo lectura: un solo fieldset desactivado apaga de golpe todos los campos
   de la pestaña (y el panel de notas). Va DENTRO de \`.dv-main\` y se reparte en
   columna: si se usara \`display: contents\` como hijo directo de \`.dv-body\`,
   el formulario, los targets y el alta de target se convertirían en columnas
   hermanas y la ficha se partiría en tres. */
.dv-fieldset {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
}
/* El formulario no pinta caja: sus hijos (título, pestañas y panel) son los
   items del fieldset y conservan el gap vertical. */
.dv-form { display: contents; }

/* Record title */
.dv-record-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text-primary);
  border: none;
  background: transparent;
  width: 100%;
  padding: 0.1rem 0;
  outline: none;
  border-bottom: 2px solid transparent;
  transition: border-color 0.2s;
}
.dv-record-title:focus { border-bottom-color: var(--accent); }
.dv-record-title::placeholder { color: var(--text-muted); }

/* Tabs */
.dv-tabs-nav {
  display: flex;
  gap: 0;
  border-bottom: 2px solid var(--border);
  flex-shrink: 0;
  background: transparent;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--border) transparent;
}
.dv-tabs-nav::-webkit-scrollbar { height: 4px; }
.dv-tabs-nav::-webkit-scrollbar-thumb { background: var(--border); border-radius: 2px; }

.dv-tab-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0.55rem 1.1rem;
  border: none;
  background: transparent;
  color: var(--text-muted);
  /* Las pestañas se renderizan con TabButton (un div, para que el \`<fieldset
     disabled>\` de modo lectura no bloquee el clic); heredamos la tipografía
     que antes aportaba el botón nativo. */
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s;
  white-space: nowrap;
}
.dv-tab-btn:hover { color: var(--text-primary); }
.dv-tab-btn .dv-tab-icon {
  width: 14px;
  height: 14px;
  flex: none;
  stroke: currentColor;
}
.dv-tab-btn:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -2px;
  border-radius: 4px;
}
.dv-tab-btn.active {
  color: var(--accent-l);
  border-bottom-color: var(--accent);
  font-weight: 600;
}

.dv-tab-pane {
  padding-top: 1.25rem;
}

/* ── Form fields (dv-field-*) ── */
.dv-field-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem 1.5rem;
  max-width: 720px;
}
@media (max-width: 640px) {
  .dv-field-grid { grid-template-columns: 1fr; }
}
.dv-field-group {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.dv-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.dv-input,
.dv-select {
  width: 100%;
  padding: 0.45rem 0.65rem;
  font-size: 0.85rem;
  color: var(--text-primary);
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 5px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.dv-input:focus,
.dv-select:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px rgba(var(--accent-rgb),.2);
}
.dv-input::placeholder { color: var(--text-muted); }
.dv-textarea {
  width: 100%;
  padding: 0.6rem 0.75rem;
  font-size: 0.85rem;
  color: var(--text-primary);
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 5px;
  outline: none;
  resize: vertical;
  min-height: 100px;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.dv-textarea:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px rgba(var(--accent-rgb),.2);
}
.dv-section-header {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  margin-top: 1.75rem;
  /* La línea de separación necesita aire por abajo: sin esto las etiquetas
     del bloque siguiente quedan pegadas al borde. */
  margin-bottom: 0.9rem;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid var(--border);
}

/* ── TopBar action buttons ── */
.dv-btn-discard {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.75rem;
  border-radius: 5px;
  font-size: 0.82rem;
  font-weight: 600;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.dv-btn-discard svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }
.dv-btn-discard:hover { background: var(--slate-200); color: var(--text-primary); }

.dv-btn-save {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.85rem;
  border-radius: 5px;
  font-size: 0.82rem;
  font-weight: 600;
  border: 1px solid transparent;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: #fff;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(var(--accent-rgb),.3);
}
.dv-btn-save svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }
.dv-btn-save:hover { background: linear-gradient(135deg, var(--accent-l), var(--accent)); box-shadow: 0 4px 12px rgba(var(--accent-rgb),.45); transform: translateY(-1px); }
.dv-btn-save:disabled { opacity: 0.5; cursor: default; transform: none; }

.dv-btn-delete {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  border-radius: 5px;
  font-size: 0.82rem;
  font-weight: 600;
  border: 1px solid rgba(220,38,38,.25);
  background: rgba(220,38,38,.1);
  color: #f87171;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.dv-btn-delete svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }
.dv-btn-delete:hover { background: rgba(220,38,38,.2); border-color: rgba(220,38,38,.4); }

/* Field groups */
.dv-section {
  margin-bottom: 1.5rem;
}
.dv-section-title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
  margin-bottom: 0.85rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid var(--border);
}

/* ── Resumen de contexto de la política ─────────────────────────────── */
.dv-context-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 1.5rem;
}
.dv-context-card {
  display: flex;
  gap: 10px;
  padding: 14px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  min-width: 0;
}
.dv-context-card-warn {
  border-color: rgba(245,158,11,.35);
  background: linear-gradient(180deg, rgba(245,158,11,.06), var(--bg-card));
}
.dv-context-icon {
  width: 36px; height: 36px; border-radius: 10px; flex: none;
  display: flex; align-items: center; justify-content: center;
  background: var(--bg-toolbar); font-size: 18px;
}
.dv-context-body { flex: 1 1; min-width: 0; }
.dv-context-kicker {
  font-size: 0.68rem; font-weight: 700; letter-spacing: 0.06em;
  text-transform: uppercase; color: var(--text-muted); margin-bottom: 3px;
}
.dv-context-title {
  font-size: 0.95rem; font-weight: 700; color: var(--text-primary); line-height: 1.25;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  overflow: hidden;
}
.dv-context-sub {
  font-size: 0.78rem; color: var(--text-muted); margin-top: 2px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.dv-context-help { font-size: 0.82rem; color: var(--text-muted); margin: -2px 0 12px; }
.dv-context-actions { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 8px; }
.dv-context-link {
  background: none; border: 0; padding: 0; cursor: pointer;
  color: var(--accent-l); font-size: 0.78rem; font-weight: 600; text-align: left;
  text-decoration: none; display: inline-block;
}
.dv-context-link:hover { color: var(--accent); text-decoration: underline; }
.dv-context-list { list-style: none; margin: 6px 0 0; padding: 0; display: flex; flex-direction: column; gap: 3px; }
.dv-context-list li {
  font-size: 0.78rem; color: var(--text-secondary);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.dv-summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)); gap: 10px; }
.dv-summary-grid > div {
  background: var(--bg-card); border: 1px solid var(--border); border-radius: 10px;
  padding: 10px 12px; display: flex; flex-direction: column; gap: 3px;
}
.dv-summary-grid span {
  font-size: 0.68rem; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.05em; color: var(--text-muted);
}
.dv-summary-grid strong { font-size: 0.9rem; color: var(--text-primary); }
.dv-table-wrap {
  border: 1px solid var(--border); border-radius: 10px; overflow: auto; background: var(--bg-card);
}
.dv-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
.dv-table th {
  text-align: left; padding: 9px 12px; font-size: 0.68rem; text-transform: uppercase;
  letter-spacing: 0.05em; color: var(--text-muted); border-bottom: 1px solid var(--border);
  background: var(--bg-toolbar);
}
.dv-table td {
  padding: 10px 12px; border-bottom: 1px solid var(--border);
  color: var(--text-primary); vertical-align: middle;
}
.dv-table tr:last-child td { border-bottom: 0; }
.dv-table tbody tr:hover td { background: var(--bg-toolbar); }
.dv-link {
  background: none; border: 0; padding: 0; cursor: pointer;
  color: var(--accent-l); font: inherit; font-weight: 600; text-align: left;
  text-decoration: none; display: inline-block;
}
.dv-link:hover { text-decoration: underline; color: var(--accent); }

/* ── Vista general del servicio ── */
.som-panel { width: 100%; min-width: 0; }
.som-notices {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  margin-bottom: 10px;
}
.som-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-toolbar);
  color: var(--text-muted);
  font-size: 0.76rem;
}
.som-notice strong { color: var(--text-secondary); font-weight: 600; }
.som-notice-icon { width: 14px; height: 14px; flex: none; }

/* ── Ficha en móvil ─────────────────────────────────────────────────────
   Las reglas viven al FINAL del archivo (sección «Móvil»), para ganar a las
   declaraciones base de \`.dv-topbar\`, \`.dv-sidebar\` y \`.dv-activity-rail\` que
   están definidas más abajo. */

/* ── Right sidebar chatter ── */
.dv-sidebar {
  width: 320px;
  flex-shrink: 0;
  border-left: 1px solid var(--border);
  background: var(--bg-card);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dv-sidebar-header {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  display: flex;
  gap: 0.5rem;
}

.dv-chatter-btn {
  padding: 0.3rem 0.75rem;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  color: var(--text-secondary);
  transition: all 0.15s;
}
.dv-chatter-btn:hover, .dv-chatter-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }

.dv-chatter-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.dv-note-input {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 0.6rem 0.75rem;
  font-size: 0.82rem;
  resize: vertical;
  min-height: 80px;
  outline: none;
  background: var(--bg-input);
  color: var(--text-primary);
  transition: border-color 0.15s;
}
.dv-note-input:focus { border-color: var(--accent); box-shadow: 0 0 0 2px rgba(var(--accent-rgb),.2); }
.dv-note-input::placeholder { color: var(--text-muted); }

.dv-chatter-entry {
  display: flex;
  gap: 0.65rem;
  font-size: 0.78rem;
}
.dv-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent-dark), var(--accent));
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  flex-shrink: 0;
}
.dv-chatter-meta {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}
.dv-chatter-who {
  font-weight: 600;
  color: var(--text-primary);
}
.dv-chatter-when {
  color: var(--text-muted);
  font-size: 0.72rem;
}
.dv-chatter-text { color: var(--text-secondary); line-height: 1.4; }

/* ── Panel de actividad y comentarios (\`CiActivityPanel\`) ──
   Es el mismo \`.dv-sidebar\` de siempre, con dos bloques (Actividad y
   Comentarios) y un botón para plegarlo. Plegado queda una pestaña fina, así que
   el panel no desaparece sin más: siempre hay dónde volver a abrirlo. */
.dv-activity-rail {
  width: 34px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
  border: 0;
  border-left: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
}
.dv-activity-rail:hover { color: var(--accent); background: var(--bg-toolbar); }
.dv-activity-rail span {
  writing-mode: vertical-rl;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.dv-activity .dv-sidebar-header { align-items: center; }

.dv-activity-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  border: 0;
  border-radius: var(--radius-sm);
  background: none;
  color: var(--text-muted);
  cursor: pointer;
}
.dv-activity-icon-btn:hover { color: var(--accent); background: var(--bg-toolbar); }

/* Servers tab table */
.dv-servers-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}
.dv-servers-table th {
  background: var(--bg-toolbar);
  padding: 0.5rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: var(--text-secondary);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid var(--border);
}
.dv-servers-table td {
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
}
.dv-servers-table tr:last-child td { border-bottom: none; }
.dv-servers-table tr:hover td { background: rgba(var(--accent-rgb),.06); }

.dv-empty-state {
  text-align: center;
  padding: 2.5rem 1rem;
  color: var(--text-muted);
  font-size: 0.85rem;
}

/* Saving spinner */
@keyframes dv-spin {
  to { transform: rotate(360deg); }
}
.dv-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid var(--text-secondary);
  border-top-color: var(--text-primary);
  border-radius: 50%;
  animation: dv-spin 0.6s linear infinite;
  display: inline-block;
}

/* ── Utility grid / field helpers ── */
.dv-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem 1.5rem;
}
.dv-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem 1.5rem;
}
@media (max-width: 768px) {
  .dv-grid-2, .dv-grid-3 { grid-template-columns: 1fr; }
}
.dv-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 0;
}
.dv-hint {
  font-size: 0.73rem;
  color: var(--text-muted);
  margin-top: 2px;
  margin-bottom: 0;
}
.dv-errors {
  background: rgba(220,38,38,.1);
  border: 1px solid rgba(220,38,38,.25);
  border-radius: 6px;
  padding: 0.75rem 1rem;
  margin-top: 1rem;
}
.dv-error-item {
  font-size: 0.82rem;
  color: #f87171;
  margin: 0 0 0.25rem 0;
}
.dv-error-item:last-child { margin-bottom: 0; }

/* ── Sidebar notes (chatter lite) ── */
.dv-sidebar-title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
  padding: 0.85rem 1rem 0.5rem;
  border-bottom: 1px solid var(--border);
}
.dv-note-input-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--border);
}
.dv-note-btn { align-self: flex-end; }
.dv-notes-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.dv-empty-notes { font-size: 0.8rem; color: var(--text-muted); text-align: center; margin: 1rem 0; }
.dv-note-item { display: flex; flex-direction: column; gap: 4px; }
.dv-note-header { display: flex; align-items: center; gap: 8px; }
.dv-note-avatar {
  width: 26px; height: 26px; border-radius: 50%;
  background: linear-gradient(135deg, var(--accent-dark), var(--accent));
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 0.6rem; font-weight: 700; flex-shrink: 0;
}
.dv-note-who { font-size: 0.78rem; font-weight: 600; color: var(--text-primary); }
.dv-note-when { font-size: 0.72rem; color: var(--text-muted); }
.dv-note-text { font-size: 0.8rem; color: var(--text-secondary); line-height: 1.4; margin: 0; }

/* ── VM detail polish ───────────────────────────────────────────────────── */
.dv-col-span-all { grid-column: 1 / -1; }

.dv-smart-btn-agent {
  border-color: rgba(var(--accent-rgb), 0.28) !important;
}

.vm-agent-inline-card {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-wrap: wrap;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 0.6rem 0.75rem;
}

.vm-badge {
  border-radius: 999px;
  padding: 0.22rem 0.55rem;
  font-size: 0.73rem;
  font-weight: 700;
  line-height: 1;
}

.vm-guest-chip {
  font-size: 0.76rem;
  font-weight: 700;
}

.vm-meta-pill {
  font-size: 0.72rem;
  color: var(--text-secondary);
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.16rem 0.45rem;
}

.vm-meta-mono {
  font-family: var(--font-mono);
}

.vm-checkbox-row {
  display: flex;
  gap: 1.3rem;
  flex-wrap: wrap;
}

.vm-checkbox-item {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.vm-agent-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 0.45rem;
  background: color-mix(in oklab, var(--accent) 7%, var(--bg-card));
  border: 1px solid color-mix(in oklab, var(--accent) 28%, var(--border));
  border-radius: 10px;
  padding: 0.65rem 0.75rem;
  font-size: 0.77rem;
  color: var(--text-secondary);
}

.vm-readonly-banner {
  margin-bottom: 0.75rem;
  padding: 0.62rem 0.75rem;
  border-radius: 8px;
  font-size: 0.78rem;
  border: 1px solid color-mix(in oklab, var(--accent) 30%, var(--border));
  background: color-mix(in oklab, var(--accent) 8%, var(--bg-card));
  color: var(--text-secondary);
}

.vm-data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.81rem;
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg-card);
}

.vm-data-table th,
.vm-data-table td {
  text-align: left;
  padding: 0.5rem 0.6rem;
  border-bottom: 1px solid var(--border);
}

.vm-data-table th {
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
  background: var(--bg-toolbar);
}

.vm-data-table tr:last-child td {
  border-bottom: none;
}

.vm-data-table tbody tr:hover td {
  background: rgba(var(--accent-rgb), 0.06);
}

.vm-input-compact {
  padding: 0.3rem 0.45rem;
  font-size: 0.78rem;
}

.vm-input-xs {
  width: 5rem;
}

.vm-icon-btn {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-secondary);
  border-radius: 6px;
  width: 1.8rem;
  height: 1.8rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.vm-icon-btn:hover {
  color: var(--text-primary);
  background: var(--bg-toolbar);
}

.vm-icon-btn-primary {
  color: var(--accent);
}

.vm-icon-btn-danger {
  color: #ef4444;
}

.vm-dashed-btn {
  margin-top: 0.75rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: transparent;
  border: 1px dashed var(--border);
  border-radius: 8px;
  padding: 0.4rem 0.75rem;
  color: var(--text-secondary);
  font-size: 0.8rem;
}

.vm-dashed-btn:hover {
  border-color: var(--accent);
  color: var(--accent-l);
  background: rgba(var(--accent-rgb), 0.06);
}

.vm-inline-actions {
  display: inline-flex;
  gap: 0.35rem;
}

.vm-nic-name-cell {
  font-weight: 700;
  color: var(--text-primary);
}

.vm-nic-type-wrap {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  flex-wrap: wrap;
}

.vm-nic-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.22rem;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: 700;
  padding: 0.1rem 0.4rem;
  border: 1px solid transparent;
}

.vm-nic-tone-accent {
  background: rgba(var(--accent-rgb), 0.14);
  color: var(--accent-l);
  border-color: rgba(var(--accent-rgb), 0.32);
}

.vm-nic-tone-cyan {
  background: rgba(14, 165, 233, 0.14);
  color: #0ea5e9;
  border-color: rgba(14, 165, 233, 0.32);
}

.vm-nic-tone-blue {
  background: rgba(59, 130, 246, 0.14);
  color: #3b82f6;
  border-color: rgba(59, 130, 246, 0.32);
}

.vm-nic-tone-neutral {
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  border-color: var(--border);
}

.vm-nic-status {
  font-size: 0.65rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 0.08rem 0.35rem;
  border: 1px solid transparent;
}

.vm-nic-status-ok {
  color: #10b981;
  background: rgba(16, 185, 129, 0.14);
  border-color: rgba(16, 185, 129, 0.3);
}

.vm-nic-status-warn {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.14);
  border-color: rgba(245, 158, 11, 0.3);
}

.vm-nic-status-muted {
  color: var(--text-muted);
  background: var(--bg-toolbar);
  border-color: var(--border);
}

.vm-mini-tag {
  margin-left: 0.35rem;
  font-size: 0.62rem;
  border-radius: 999px;
  padding: 0.06rem 0.4rem;
  background: rgba(16, 185, 129, 0.14);
  color: #10b981;
  font-weight: 700;
}

.vm-cell-mono {
  font-family: var(--font-mono);
}

.vm-cell-muted {
  color: var(--text-secondary);
}

.vm-cell-subtle {
  color: var(--text-muted);
}

.vm-cell-ip {
  color: var(--accent-l);
}

.vm-stack-inline {
  display: inline-flex;
  gap: 0.35rem;
  align-items: center;
  flex-wrap: wrap;
}

.vm-nic-pg-name {
  font-weight: 700;
  color: var(--text-primary);
}

.vm-nic-vlan-chip {
  border-radius: 999px;
  padding: 0.06rem 0.4rem;
  font-size: 0.66rem;
  background: rgba(var(--accent-rgb), 0.14);
  color: var(--accent-l);
  font-family: var(--font-mono);
}

.vm-nic-vswitch {
  font-size: 0.7rem;
  color: var(--text-muted);
}

.vm-empty-inline {
  font-style: italic;
  color: var(--text-muted);
  font-size: 0.76rem;
}

.vm-inventory-grid {
  display: grid;
  gap: 0.95rem;
}

.vm-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 0.55rem;
}

.vm-kpi-card {
  border: 1px solid var(--border);
  border-radius: 10px;
  background: linear-gradient(180deg, color-mix(in oklab, var(--bg-card) 86%, var(--accent) 14%), var(--bg-card));
  padding: 0.52rem 0.6rem;
  opacity: 0;
  transform: translateY(6px) scale(0.985);
  animation: vm-kpi-in 320ms cubic-bezier(0.2, 0.7, 0, 1) forwards;
  animation-delay: var(--kpi-delay, 0ms);
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.vm-kpi-card:hover {
  transform: translateY(-1px);
  border-color: color-mix(in oklab, var(--accent) 40%, var(--border));
  box-shadow: 0 8px 18px rgba(var(--accent-rgb), 0.16);
}

@keyframes vm-kpi-in {
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.vm-kpi-head {
  display: flex;
  align-items: center;
  gap: 0.32rem;
  color: var(--text-secondary);
}

.vm-kpi-icon {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-l);
  background: rgba(var(--accent-rgb), 0.14);
}

.vm-kpi-label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
}

.vm-kpi-value {
  margin-top: 0.22rem;
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--text-primary);
}

.vm-inventory-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  padding: 0.85rem;
}

.vm-inventory-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.55rem;
}

.vm-table-toolbar {
  margin-bottom: 0.45rem;
}

.vm-table-scroll {
  max-height: 240px;
  overflow: auto;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.vm-compact-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: var(--bg-card);
  font-size: 0.76rem;
}

.vm-compact-table th,
.vm-compact-table td {
  text-align: left;
  padding: 0.38rem 0.48rem;
  border-bottom: 1px solid var(--border);
}

.vm-compact-table th {
  font-size: 0.67rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  background: var(--bg-toolbar);
  position: sticky;
  top: 0;
  z-index: 1;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.vm-compact-table tr:last-child td {
  border-bottom: none;
}

.vm-compact-table tbody tr:hover td {
  background: rgba(var(--accent-rgb), 0.06);
}

.vm-mt-md {
  margin-top: 0.85rem;
}

.vm-empty-note {
  font-size: 0.76rem;
  color: var(--text-muted);
}

.vm-chip-list {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.vm-chip {
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.18rem 0.5rem;
  font-size: 0.72rem;
  font-family: var(--font-mono);
}

.vm-chip.is-primary {
  background: rgba(var(--accent-rgb), 0.14);
  color: var(--accent-l);
  border-color: rgba(var(--accent-rgb), 0.3);
}

.vm-inventory-list {
  display: grid;
  gap: 0.38rem;
}

.vm-inventory-list-spaced {
  margin-bottom: 0.9rem;
}

.vm-inventory-scroll {
  max-height: 220px;
  overflow: auto;
  padding-right: 0.35rem;
}

.vm-row-text {
  font-size: 0.78rem;
  color: var(--text-secondary);
  line-height: 1.35;
}

.vm-row-meta {
  color: var(--text-muted);
}

.vm-row-meta-muted {
  opacity: 0.92;
}

.vm-agent-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1060;
  background: rgba(2, 6, 23, 0.62);
  display: grid;
  place-items: center;
  padding: 1rem;
}

.vm-agent-modal {
  width: min(760px, 96vw);
  border-radius: 14px;
  border: 1px solid var(--border);
  background: var(--bg-surface);
  box-shadow: 0 24px 48px rgba(2, 6, 23, 0.35);
  color: var(--text-primary);
  padding: 1rem;
}

.vm-agent-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.vm-agent-modal-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.vm-agent-modal-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

@media (max-width: 720px) {
  .vm-agent-modal-grid {
    grid-template-columns: 1fr;
  }
}

.vm-agent-modal-card {
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--slate-100);
  padding: 0.65rem 0.7rem;
}

.vm-agent-modal-label {
  font-size: 0.68rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 0.3rem;
  font-weight: 700;
}

.vm-agent-modal-main {
  font-size: 0.83rem;
  color: var(--text-primary);
  font-weight: 600;
}

.vm-agent-modal-help {
  margin-top: 0.35rem;
  font-size: 0.73rem;
  color: var(--text-secondary);
  line-height: 1.35;
}

.vm-agent-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.9rem;
}

/* ═══════════════════════════════════════════════════════════════════════════
   MÓVIL — la ficha a pantalla completa
   ───────────────────────────────────────────────────────────────────────────
   El panel de actividad mide 320 px fijos: en un móvil de 390 dejaba al
   formulario con 70 px (se veía una tira vertical). Aquí el formulario ocupa
   todo el ancho y todo el alto; el panel de actividad flota encima cuando se
   abre desde su pestaña. El topbar se desplaza en horizontal porque los
   botones con texto no caben. El bloque va AL FINAL a propósito: así gana a
   las declaraciones base de \`.dv-topbar\`, \`.dv-sidebar\` y \`.dv-activity-rail\`.
   ═══════════════════════════════════════════════════════════════════════════ */
@media (max-width: 768px) {
  .dv-topbar {
    padding: 0 0.5rem;
    gap: 0.4rem;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .dv-topbar::-webkit-scrollbar { display: none; }
  .dv-topbar > * { flex-shrink: 0; }
  .dv-breadcrumb,
  .dv-topbar-sep { display: none; }
  .dv-topbar-spacer { flex: 1 0 8px; }

  .dv-btn {
    padding: 0.3rem 0.6rem;
    font-size: 0.78rem;
  }

  .dv-body {
    flex-direction: column;
    position: relative;
  }

  .dv-main {
    flex: 1 1 auto;
    min-height: 0;
    padding: 1rem;
  }

  .dv-main.sf2-main { padding: 0; }

  /* Abierto: hoja inferior que flota sobre el formulario (no reparte altura). */
  .dv-sidebar.dv-activity {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    max-height: 55dvh;
    z-index: 30;
    border-left: 0;
    border-top: 1px solid var(--border);
    border-radius: 14px 14px 0 0;
    box-shadow: 0 -10px 28px rgba(0, 0, 0, 0.28);
  }

  /* Plegado: pestaña flotante abajo a la derecha. */
  .dv-activity-rail {
    position: absolute;
    right: 0.6rem;
    bottom: 0.6rem;
    width: max-content;
    height: 36px;
    flex-direction: row;
    padding: 0 14px;
    gap: 6px;
    z-index: 20;
    border: 1px solid var(--border);
    border-left: 1px solid var(--border);
    border-radius: 999px;
    background: var(--bg-surface, var(--bg-card));
    box-shadow: var(--shadow-md);
    white-space: nowrap;
  }

  .dv-activity-rail span { white-space: nowrap; }

  .dv-record-title { font-size: 1.35rem; }
}

/* A 390 px el texto «Actividad» no cabe junto al icono y se partía letra a
   letra. Se queda el icono; el \`title\` del botón ya lo explica. */
@media (max-width: 480px) {
  .dv-activity-rail {
    width: 40px;
    padding: 0;
    justify-content: center;
  }

  .dv-activity-rail span { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/DetailView.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,kBAAkB;AAClB;EACE,eAAe;EACf,+DAA+D;EAC/D,WAAW;EACX,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;AACA,qBAAqB,6BAA6B,EAAE,0BAA0B,EAAE;AAChF,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,4EAA4E;AAC9E;;AAEA,oBAAoB,WAAW,EAAE,YAAY,EAAE;;AAE/C;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,yBAAyB,aAAa,EAAE,eAAe,EAAE;;AAEzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,oBAAoB,SAAO,EAAE;;AAE7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;AACA,cAAc,WAAW,EAAE,YAAY,EAAE;;AAEzC;EACE,sEAAsE;EACtE,WAAW;EACX,yBAAyB;EACzB,iDAAiD;AACnD;AACA,wBAAwB,mEAAmE,EAAE,kDAAkD,EAAE,2BAA2B,EAAE;AAC9K,2BAA2B,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE;;AAE3E;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA,0BAA0B,4BAA4B,EAAE,0BAA0B,EAAE;;AAEpF;EACE,+BAA+B;EAC/B,cAAc;EACd,iCAAiC;AACnC;AACA,uBAAuB,8BAA8B,EAAE;;AAEvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,oBAAoB,gCAAgC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AAC9G,sBAAsB,+BAA+B,EAAE,cAAc,EAAE,oCAAoC,EAAE;;AAE7G,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,YAAY;AACd;AACA,4BAA4B,oCAAoC,EAAE;AAClE,sBAAsB,uCAAuC,EAAE;;AAE/D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP;;+DAE6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;;;6CAI6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;EACT,YAAY;AACd;AACA;oDACoD;AACpD,WAAW,iBAAiB,EAAE;;AAE9B,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,6BAA6B;AAC/B;AACA,yBAAyB,kCAAkC,EAAE;AAC7D,gCAAgC,wBAAwB,EAAE;;AAE1D,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,sCAAsC;EACtC,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;AAC5C;AACA,kCAAkC,WAAW,EAAE;AAC/C,wCAAwC,yBAAyB,EAAE,kBAAkB,EAAE;;AAEvF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB;;0CAEwC;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA,oBAAoB,0BAA0B,EAAE;AAChD;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB,0BAA0B,EAAE;AAC/C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,gDAAgD;AAClD;AACA;;EAEE,2BAA2B;EAC3B,gDAAgD;AAClD;AACA,yBAAyB,wBAAwB,EAAE;AACnD;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;AAClD;AACA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB;oDACkD;EAClD,qBAAqB;EACrB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,UAAU,EAAE;AACnF,wBAAwB,4BAA4B,EAAE,0BAA0B,EAAE;;AAElF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,sEAAsE;EACtE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gDAAgD;AAClD;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,UAAU,EAAE;AAChF,qBAAqB,mEAAmE,EAAE,kDAAkD,EAAE,2BAA2B,EAAE;AAC3K,wBAAwB,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE;;AAExE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA,qBAAqB,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,UAAU,EAAE;AAClF,uBAAuB,8BAA8B,EAAE,gCAAgC,EAAE;;AAEzF,iBAAiB;AACjB;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,yEAAyE;AAC3E;AACA;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,UAAU;EAC1D,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,6BAA6B,EAAE,eAAe;AAChD;AACA,mBAAmB,SAAO,EAAE,YAAY,EAAE;AAC1C;EACE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB;EAC5D,yBAAyB,EAAE,wBAAwB,EAAE,kBAAkB;AACzE;AACA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,iBAAiB;EACnF,oBAAoB,EAAE,qBAAqB,EAAE,4BAA4B;EACzE,gBAAgB;AAClB;AACA;EACE,kBAAkB,EAAE,wBAAwB,EAAE,eAAe;EAC7D,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA,mBAAmB,kBAAkB,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;AACtF,sBAAsB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;AACjF;EACE,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,eAAe;EACxD,sBAAsB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB;EAC9E,qBAAqB,EAAE,qBAAqB;AAC9C;AACA,yBAAyB,oBAAoB,EAAE,0BAA0B,EAAE;AAC3E,mBAAmB,gBAAgB,EAAE,eAAe,EAAE,UAAU,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnH;EACE,kBAAkB,EAAE,4BAA4B;EAChD,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA,mBAAmB,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE;AAC1G;EACE,0BAA0B,EAAE,+BAA+B,EAAE,mBAAmB;EAChF,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACrE;AACA;EACE,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB;EAC/D,sBAAsB,EAAE,wBAAwB;AAClD;AACA,0BAA0B,iBAAiB,EAAE,0BAA0B,EAAE;AACzE;EACE,+BAA+B,EAAE,mBAAmB,EAAE,cAAc,EAAE,0BAA0B;AAClG;AACA,YAAY,WAAW,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AACxE;EACE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,yBAAyB;EAClF,sBAAsB,EAAE,wBAAwB,EAAE,sCAAsC;EACxF,6BAA6B;AAC/B;AACA;EACE,kBAAkB,EAAE,sCAAsC;EAC1D,0BAA0B,EAAE,sBAAsB;AACpD;AACA,6BAA6B,gBAAgB,EAAE;AAC/C,8BAA8B,6BAA6B,EAAE;AAC7D;EACE,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,eAAe;EACxD,sBAAsB,EAAE,aAAa,EAAE,gBAAgB,EAAE,gBAAgB;EACzE,qBAAqB,EAAE,qBAAqB;AAC9C;AACA,iBAAiB,0BAA0B,EAAE,oBAAoB,EAAE;;AAEnE,qCAAqC;AACrC,aAAa,WAAW,EAAE,YAAY,EAAE;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;AACpB;AACA,qBAAqB,4BAA4B,EAAE,gBAAgB,EAAE;AACrE,mBAAmB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE;;AAE1D;;;+BAG+B;;AAE/B,gCAAgC;AAChC;EACE,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;AACvB;AACA,gDAAgD,yBAAyB,EAAE,WAAW,EAAE,2BAA2B,EAAE;;AAErH;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;AACA,uBAAuB,2BAA2B,EAAE,gDAAgD,EAAE;AACtG,8BAA8B,wBAAwB,EAAE;;AAExD;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sEAAsE;EACtE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;AACA,mBAAmB,4BAA4B,EAAE,gBAAgB,EAAE;;AAEnE;;;wEAGwE;AACxE;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;EACf,yCAAyC;AAC3C;AACA,0BAA0B,oBAAoB,EAAE,6BAA6B,EAAE;AAC/E;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,kCAAkC,mBAAmB,EAAE;;AAEvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA,8BAA8B,oBAAoB,EAAE,6BAA6B,EAAE;;AAEnF,sBAAsB;AACtB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;AAC5B;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,gCAAgC,uCAAuC,EAAE;;AAEzE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,yBAAyB,0BAA0B,EAAE;AACvD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;AACA,4BAA4B,gBAAgB,EAAE;;AAE9C,uCAAuC;AACvC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,sCAAsC;AACxC;AACA,eAAe,oBAAoB,EAAE;AACrC;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA,kBAAkB,iBAAiB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACnG,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACjE,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,sEAAsE;EACtE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,WAAW,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,cAAc;AAClE;AACA,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACjF,gBAAgB,kBAAkB,EAAE,wBAAwB,EAAE;AAC9D,gBAAgB,iBAAiB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAE9F,8EAA8E;AAC9E,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,iEAAiE;EACjE,uEAAuE;EACvE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,uEAAuE;EACvE,iEAAiE;EACjE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,+GAA+G;EAC/G,uBAAuB;EACvB,UAAU;EACV,uCAAuC;EACvC,gEAAgE;EAChE,sCAAsC;EACtC,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,mEAAmE;EACnE,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,4CAA4C;EAC5C,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;;;;gFASgF;AAChF;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,gCAAgC,aAAa,EAAE;EAC/C,iBAAiB,cAAc,EAAE;EACjC;mBACiB,aAAa,EAAE;EAChC,oBAAoB,aAAa,EAAE;;EAEnC;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;EACf;;EAEA,oBAAoB,UAAU,EAAE;;EAEhC,8EAA8E;EAC9E;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,mCAAmC;IACnC,4BAA4B;IAC5B,4CAA4C;EAC9C;;EAEA,kDAAkD;EAClD;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,WAAW;IACX,+BAA+B;IAC/B,oCAAoC;IACpC,oBAAoB;IACpB,6CAA6C;IAC7C,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA,yBAAyB,mBAAmB,EAAE;;EAE9C,mBAAmB,kBAAkB,EAAE;AACzC;;AAEA;kEACkE;AAClE;EACE;IACE,WAAW;IACX,UAAU;IACV,uBAAuB;EACzB;;EAEA,yBAAyB,aAAa,EAAE;AAC1C","sourcesContent":["/**\r\n * DetailView - Odoo-style full-screen record form — DARK INDIGO THEME\r\n * Covers the main content area (right of sidebar, below navbar)\r\n * Sidebar (240px) and Navbar (--app-topbar-h) remain visible and fixed.\r\n */\r\n\r\n/* ── Overlay ── */\r\n.dv-overlay {\r\n  position: fixed;\r\n  top: calc(var(--app-topbar-h, 69px) + var(--app-crumb-h, 42px));\r\n  left: 240px;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: var(--slate-50);\r\n  z-index: 500;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .dv-overlay {\r\n    left: 0;\r\n  }\r\n}\r\n\r\n/* ── Top action bar ── */\r\n.dv-topbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0 1.25rem;\r\n  height: 48px;\r\n  background: var(--bg-card);\r\n  border-bottom: 1px solid var(--border);\r\n  flex-shrink: 0;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.dv-back-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-secondary);\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  padding: 0.3rem 0.5rem;\r\n  border-radius: 4px;\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n}\r\n.dv-back-btn:hover { background: var(--bg-toolbar); color: var(--text-primary); }\r\n.dv-back-btn svg { width: 16px; height: 16px; }\r\n\r\n.dv-topbar-sep {\r\n  width: 1px;\r\n  height: 20px;\r\n  background: var(--border);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Contador de fichas: ‹ 3 / 27 › */\r\n.dv-pager {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  flex-shrink: 0;\r\n  padding-left: 0.75rem;\r\n  margin-left: 0.25rem;\r\n  border-left: 1px solid var(--border);\r\n}\r\n\r\n.dv-pager-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 26px;\r\n  height: 26px;\r\n  padding: 0;\r\n  background: none;\r\n  border: 1px solid transparent;\r\n  border-radius: 7px;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.dv-pager-btn svg { width: 16px; height: 16px; }\r\n\r\n.dv-pager-btn:hover:not(:disabled) {\r\n  background: var(--bg-toolbar);\r\n  border-color: var(--border);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.dv-pager-btn:disabled { opacity: 0.35; cursor: default; }\r\n\r\n.dv-pager-count {\r\n  min-width: 4.5ch;\r\n  text-align: center;\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.dv-breadcrumb {\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n}\r\n.dv-breadcrumb-current {\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.dv-topbar-spacer { flex: 1; }\r\n\r\n.dv-topbar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.dv-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  padding: 0.3rem 0.85rem;\r\n  border-radius: 5px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  border: 1px solid transparent;\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n  text-decoration: none;\r\n}\r\n.dv-btn svg { width: 14px; height: 14px; }\r\n\r\n.dv-btn-primary {\r\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\r\n  color: #fff;\r\n  border-color: transparent;\r\n  box-shadow: 0 2px 8px rgba(var(--accent-rgb),.35);\r\n}\r\n.dv-btn-primary:hover { background: linear-gradient(135deg, var(--accent-l), var(--accent)); box-shadow: 0 4px 12px rgba(var(--accent-rgb),.45); transform: translateY(-1px); }\r\n.dv-btn-primary:disabled { opacity: 0.5; cursor: default; transform: none; }\r\n\r\n.dv-btn-secondary {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  border-color: var(--border);\r\n}\r\n.dv-btn-secondary:hover { background: var(--slate-200); color: var(--text-primary); }\r\n\r\n.dv-btn-danger {\r\n  background: rgba(220,38,38,.12);\r\n  color: #f87171;\r\n  border-color: rgba(220,38,38,.25);\r\n}\r\n.dv-btn-danger:hover { background: rgba(220,38,38,.2); }\r\n\r\n.dv-status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  padding: 0.2rem 0.65rem;\r\n  border-radius: 99px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n.dv-status-active { background: rgba(16,185,129,.15); color: #6ee7b7; border: 1px solid rgba(16,185,129,.25); }\r\n.dv-status-inactive { background: rgba(220,38,38,.12); color: #f87171; border: 1px solid rgba(220,38,38,.2); }\r\n\r\n/* ── SmartButtons bar ── */\r\n.dv-smartbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0;\r\n  background: var(--bg-card);\r\n  border-bottom: 1px solid var(--border);\r\n  flex-shrink: 0;\r\n  overflow-x: auto;\r\n  padding: 0 1rem;\r\n}\r\n\r\n.dv-smart-btn {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0.6rem 1.25rem;\r\n  border: none;\r\n  border-right: 1px solid var(--border);\r\n  background: transparent;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n  min-width: 90px;\r\n  gap: 0.15rem;\r\n}\r\n.dv-smart-btn:first-child { border-left: 1px solid var(--border); }\r\n.dv-smart-btn:hover { background: rgba(var(--accent-rgb),.08); }\r\n\r\n.dv-smart-btn-value {\r\n  font-size: 1.2rem;\r\n  font-weight: 700;\r\n  color: var(--accent-l);\r\n  line-height: 1;\r\n}\r\n.dv-smart-btn-label {\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  white-space: nowrap;\r\n}\r\n.dv-smart-btn-icon {\r\n  font-size: 1rem;\r\n  margin-bottom: 0.1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--accent-l);\r\n}\r\n.dv-smart-btn-icon svg {\r\n  width: 18px !important;\r\n  height: 18px !important;\r\n  flex-shrink: 0;\r\n  stroke: currentColor !important;\r\n  fill: none !important;\r\n}\r\n\r\n/* ── Body (tabs + sidebar) ── */\r\n.dv-body {\r\n  display: flex;\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n/* ── Main panel ── */\r\n.dv-main {\r\n  flex: 1;\r\n  /* `min-width: 0` es obligatorio: sin él, un `flex: 1` no baja de su contenido\r\n     mínimo y el formulario empujaba el panel de actividad fuera de la ficha\r\n     (se veía solo una franja del panel en el borde derecho). */\r\n  min-width: 0;\r\n  overflow-y: auto;\r\n  padding: 1.5rem 2rem;\r\n  background: var(--slate-50);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.25rem;\r\n}\r\n\r\n/* Modo lectura: un solo fieldset desactivado apaga de golpe todos los campos\r\n   de la pestaña (y el panel de notas). Va DENTRO de `.dv-main` y se reparte en\r\n   columna: si se usara `display: contents` como hijo directo de `.dv-body`,\r\n   el formulario, los targets y el alta de target se convertirían en columnas\r\n   hermanas y la ficha se partiría en tres. */\r\n.dv-fieldset {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.25rem;\r\n  border: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  min-width: 0;\r\n}\r\n/* El formulario no pinta caja: sus hijos (título, pestañas y panel) son los\r\n   items del fieldset y conservan el gap vertical. */\r\n.dv-form { display: contents; }\r\n\r\n/* Record title */\r\n.dv-record-title {\r\n  font-size: 1.75rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  border: none;\r\n  background: transparent;\r\n  width: 100%;\r\n  padding: 0.1rem 0;\r\n  outline: none;\r\n  border-bottom: 2px solid transparent;\r\n  transition: border-color 0.2s;\r\n}\r\n.dv-record-title:focus { border-bottom-color: var(--accent); }\r\n.dv-record-title::placeholder { color: var(--text-muted); }\r\n\r\n/* Tabs */\r\n.dv-tabs-nav {\r\n  display: flex;\r\n  gap: 0;\r\n  border-bottom: 2px solid var(--border);\r\n  flex-shrink: 0;\r\n  background: transparent;\r\n  overflow-x: auto;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--border) transparent;\r\n}\r\n.dv-tabs-nav::-webkit-scrollbar { height: 4px; }\r\n.dv-tabs-nav::-webkit-scrollbar-thumb { background: var(--border); border-radius: 2px; }\r\n\r\n.dv-tab-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 0.55rem 1.1rem;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  /* Las pestañas se renderizan con TabButton (un div, para que el `<fieldset\r\n     disabled>` de modo lectura no bloquee el clic); heredamos la tipografía\r\n     que antes aportaba el botón nativo. */\r\n  font-family: inherit;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  border-bottom: 2px solid transparent;\r\n  margin-bottom: -2px;\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n}\r\n.dv-tab-btn:hover { color: var(--text-primary); }\r\n.dv-tab-btn .dv-tab-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex: none;\r\n  stroke: currentColor;\r\n}\r\n.dv-tab-btn:focus-visible {\r\n  outline: 2px solid var(--accent);\r\n  outline-offset: -2px;\r\n  border-radius: 4px;\r\n}\r\n.dv-tab-btn.active {\r\n  color: var(--accent-l);\r\n  border-bottom-color: var(--accent);\r\n  font-weight: 600;\r\n}\r\n\r\n.dv-tab-pane {\r\n  padding-top: 1.25rem;\r\n}\r\n\r\n/* ── Form fields (dv-field-*) ── */\r\n.dv-field-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 1rem 1.5rem;\r\n  max-width: 720px;\r\n}\r\n@media (max-width: 640px) {\r\n  .dv-field-grid { grid-template-columns: 1fr; }\r\n}\r\n.dv-field-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n}\r\n.dv-label {\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n.dv-input,\r\n.dv-select {\r\n  width: 100%;\r\n  padding: 0.45rem 0.65rem;\r\n  font-size: 0.85rem;\r\n  color: var(--text-primary);\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--border);\r\n  border-radius: 5px;\r\n  outline: none;\r\n  transition: border-color 0.15s, box-shadow 0.15s;\r\n}\r\n.dv-input:focus,\r\n.dv-select:focus {\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 2px rgba(var(--accent-rgb),.2);\r\n}\r\n.dv-input::placeholder { color: var(--text-muted); }\r\n.dv-textarea {\r\n  width: 100%;\r\n  padding: 0.6rem 0.75rem;\r\n  font-size: 0.85rem;\r\n  color: var(--text-primary);\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--border);\r\n  border-radius: 5px;\r\n  outline: none;\r\n  resize: vertical;\r\n  min-height: 100px;\r\n  transition: border-color 0.15s, box-shadow 0.15s;\r\n}\r\n.dv-textarea:focus {\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 2px rgba(var(--accent-rgb),.2);\r\n}\r\n.dv-section-header {\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--text-muted);\r\n  margin-top: 1.75rem;\r\n  /* La línea de separación necesita aire por abajo: sin esto las etiquetas\r\n     del bloque siguiente quedan pegadas al borde. */\r\n  margin-bottom: 0.9rem;\r\n  padding-bottom: 0.45rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n/* ── TopBar action buttons ── */\r\n.dv-btn-discard {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  padding: 0.3rem 0.75rem;\r\n  border-radius: 5px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n}\r\n.dv-btn-discard svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }\r\n.dv-btn-discard:hover { background: var(--slate-200); color: var(--text-primary); }\r\n\r\n.dv-btn-save {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  padding: 0.3rem 0.85rem;\r\n  border-radius: 5px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  border: 1px solid transparent;\r\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\r\n  color: #fff;\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n  box-shadow: 0 2px 8px rgba(var(--accent-rgb),.3);\r\n}\r\n.dv-btn-save svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }\r\n.dv-btn-save:hover { background: linear-gradient(135deg, var(--accent-l), var(--accent)); box-shadow: 0 4px 12px rgba(var(--accent-rgb),.45); transform: translateY(-1px); }\r\n.dv-btn-save:disabled { opacity: 0.5; cursor: default; transform: none; }\r\n\r\n.dv-btn-delete {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  padding: 0.3rem 0.6rem;\r\n  border-radius: 5px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  border: 1px solid rgba(220,38,38,.25);\r\n  background: rgba(220,38,38,.1);\r\n  color: #f87171;\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n}\r\n.dv-btn-delete svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }\r\n.dv-btn-delete:hover { background: rgba(220,38,38,.2); border-color: rgba(220,38,38,.4); }\r\n\r\n/* Field groups */\r\n.dv-section {\r\n  margin-bottom: 1.5rem;\r\n}\r\n.dv-section-title {\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  color: var(--text-muted);\r\n  margin-bottom: 0.85rem;\r\n  padding-bottom: 0.4rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n/* ── Resumen de contexto de la política ─────────────────────────────── */\r\n.dv-context-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 12px;\r\n  margin-bottom: 1.5rem;\r\n}\r\n.dv-context-card {\r\n  display: flex;\r\n  gap: 10px;\r\n  padding: 14px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  min-width: 0;\r\n}\r\n.dv-context-card-warn {\r\n  border-color: rgba(245,158,11,.35);\r\n  background: linear-gradient(180deg, rgba(245,158,11,.06), var(--bg-card));\r\n}\r\n.dv-context-icon {\r\n  width: 36px; height: 36px; border-radius: 10px; flex: none;\r\n  display: flex; align-items: center; justify-content: center;\r\n  background: var(--bg-toolbar); font-size: 18px;\r\n}\r\n.dv-context-body { flex: 1; min-width: 0; }\r\n.dv-context-kicker {\r\n  font-size: 0.68rem; font-weight: 700; letter-spacing: 0.06em;\r\n  text-transform: uppercase; color: var(--text-muted); margin-bottom: 3px;\r\n}\r\n.dv-context-title {\r\n  font-size: 0.95rem; font-weight: 700; color: var(--text-primary); line-height: 1.25;\r\n  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n.dv-context-sub {\r\n  font-size: 0.78rem; color: var(--text-muted); margin-top: 2px;\r\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\r\n}\r\n.dv-context-help { font-size: 0.82rem; color: var(--text-muted); margin: -2px 0 12px; }\r\n.dv-context-actions { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 8px; }\r\n.dv-context-link {\r\n  background: none; border: 0; padding: 0; cursor: pointer;\r\n  color: var(--accent-l); font-size: 0.78rem; font-weight: 600; text-align: left;\r\n  text-decoration: none; display: inline-block;\r\n}\r\n.dv-context-link:hover { color: var(--accent); text-decoration: underline; }\r\n.dv-context-list { list-style: none; margin: 6px 0 0; padding: 0; display: flex; flex-direction: column; gap: 3px; }\r\n.dv-context-list li {\r\n  font-size: 0.78rem; color: var(--text-secondary);\r\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\r\n}\r\n.dv-summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)); gap: 10px; }\r\n.dv-summary-grid > div {\r\n  background: var(--bg-card); border: 1px solid var(--border); border-radius: 10px;\r\n  padding: 10px 12px; display: flex; flex-direction: column; gap: 3px;\r\n}\r\n.dv-summary-grid span {\r\n  font-size: 0.68rem; font-weight: 700; text-transform: uppercase;\r\n  letter-spacing: 0.05em; color: var(--text-muted);\r\n}\r\n.dv-summary-grid strong { font-size: 0.9rem; color: var(--text-primary); }\r\n.dv-table-wrap {\r\n  border: 1px solid var(--border); border-radius: 10px; overflow: auto; background: var(--bg-card);\r\n}\r\n.dv-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }\r\n.dv-table th {\r\n  text-align: left; padding: 9px 12px; font-size: 0.68rem; text-transform: uppercase;\r\n  letter-spacing: 0.05em; color: var(--text-muted); border-bottom: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n}\r\n.dv-table td {\r\n  padding: 10px 12px; border-bottom: 1px solid var(--border);\r\n  color: var(--text-primary); vertical-align: middle;\r\n}\r\n.dv-table tr:last-child td { border-bottom: 0; }\r\n.dv-table tbody tr:hover td { background: var(--bg-toolbar); }\r\n.dv-link {\r\n  background: none; border: 0; padding: 0; cursor: pointer;\r\n  color: var(--accent-l); font: inherit; font-weight: 600; text-align: left;\r\n  text-decoration: none; display: inline-block;\r\n}\r\n.dv-link:hover { text-decoration: underline; color: var(--accent); }\r\n\r\n/* ── Vista general del servicio ── */\r\n.som-panel { width: 100%; min-width: 0; }\r\n.som-notices {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 6px;\r\n  margin-bottom: 10px;\r\n}\r\n.som-notice {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 7px 10px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-muted);\r\n  font-size: 0.76rem;\r\n}\r\n.som-notice strong { color: var(--text-secondary); font-weight: 600; }\r\n.som-notice-icon { width: 14px; height: 14px; flex: none; }\r\n\r\n/* ── Ficha en móvil ─────────────────────────────────────────────────────\r\n   Las reglas viven al FINAL del archivo (sección «Móvil»), para ganar a las\r\n   declaraciones base de `.dv-topbar`, `.dv-sidebar` y `.dv-activity-rail` que\r\n   están definidas más abajo. */\r\n\r\n/* ── Right sidebar chatter ── */\r\n.dv-sidebar {\r\n  width: 320px;\r\n  flex-shrink: 0;\r\n  border-left: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.dv-sidebar-header {\r\n  padding: 0.85rem 1rem;\r\n  border-bottom: 1px solid var(--border);\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.dv-chatter-btn {\r\n  padding: 0.3rem 0.75rem;\r\n  border-radius: 4px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  transition: all 0.15s;\r\n}\r\n.dv-chatter-btn:hover, .dv-chatter-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }\r\n\r\n.dv-chatter-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.dv-note-input {\r\n  width: 100%;\r\n  border: 1px solid var(--border);\r\n  border-radius: 6px;\r\n  padding: 0.6rem 0.75rem;\r\n  font-size: 0.82rem;\r\n  resize: vertical;\r\n  min-height: 80px;\r\n  outline: none;\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n  transition: border-color 0.15s;\r\n}\r\n.dv-note-input:focus { border-color: var(--accent); box-shadow: 0 0 0 2px rgba(var(--accent-rgb),.2); }\r\n.dv-note-input::placeholder { color: var(--text-muted); }\r\n\r\n.dv-chatter-entry {\r\n  display: flex;\r\n  gap: 0.65rem;\r\n  font-size: 0.78rem;\r\n}\r\n.dv-avatar {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, var(--accent-dark), var(--accent));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #fff;\r\n  font-size: 0.65rem;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n.dv-chatter-meta {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n.dv-chatter-who {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n.dv-chatter-when {\r\n  color: var(--text-muted);\r\n  font-size: 0.72rem;\r\n}\r\n.dv-chatter-text { color: var(--text-secondary); line-height: 1.4; }\r\n\r\n/* ── Panel de actividad y comentarios (`CiActivityPanel`) ──\r\n   Es el mismo `.dv-sidebar` de siempre, con dos bloques (Actividad y\r\n   Comentarios) y un botón para plegarlo. Plegado queda una pestaña fina, así que\r\n   el panel no desaparece sin más: siempre hay dónde volver a abrirlo. */\r\n.dv-activity-rail {\r\n  width: 34px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 0;\r\n  border: 0;\r\n  border-left: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: color 0.15s, background 0.15s;\r\n}\r\n.dv-activity-rail:hover { color: var(--accent); background: var(--bg-toolbar); }\r\n.dv-activity-rail span {\r\n  writing-mode: vertical-rl;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.dv-activity .dv-sidebar-header { align-items: center; }\r\n\r\n.dv-activity-icon-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 3px;\r\n  border: 0;\r\n  border-radius: var(--radius-sm);\r\n  background: none;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n}\r\n.dv-activity-icon-btn:hover { color: var(--accent); background: var(--bg-toolbar); }\r\n\r\n/* Servers tab table */\r\n.dv-servers-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.82rem;\r\n}\r\n.dv-servers-table th {\r\n  background: var(--bg-toolbar);\r\n  padding: 0.5rem 0.75rem;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.dv-servers-table td {\r\n  padding: 0.6rem 0.75rem;\r\n  border-bottom: 1px solid var(--border);\r\n  color: var(--text-primary);\r\n}\r\n.dv-servers-table tr:last-child td { border-bottom: none; }\r\n.dv-servers-table tr:hover td { background: rgba(var(--accent-rgb),.06); }\r\n\r\n.dv-empty-state {\r\n  text-align: center;\r\n  padding: 2.5rem 1rem;\r\n  color: var(--text-muted);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n/* Saving spinner */\r\n@keyframes dv-spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n.dv-spinner {\r\n  width: 14px;\r\n  height: 14px;\r\n  border: 2px solid var(--text-secondary);\r\n  border-top-color: var(--text-primary);\r\n  border-radius: 50%;\r\n  animation: dv-spin 0.6s linear infinite;\r\n  display: inline-block;\r\n}\r\n\r\n/* ── Utility grid / field helpers ── */\r\n.dv-grid-2 {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 1rem 1.5rem;\r\n}\r\n.dv-grid-3 {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 1rem 1.5rem;\r\n}\r\n@media (max-width: 768px) {\r\n  .dv-grid-2, .dv-grid-3 { grid-template-columns: 1fr; }\r\n}\r\n.dv-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n  margin-bottom: 0;\r\n}\r\n.dv-hint {\r\n  font-size: 0.73rem;\r\n  color: var(--text-muted);\r\n  margin-top: 2px;\r\n  margin-bottom: 0;\r\n}\r\n.dv-errors {\r\n  background: rgba(220,38,38,.1);\r\n  border: 1px solid rgba(220,38,38,.25);\r\n  border-radius: 6px;\r\n  padding: 0.75rem 1rem;\r\n  margin-top: 1rem;\r\n}\r\n.dv-error-item {\r\n  font-size: 0.82rem;\r\n  color: #f87171;\r\n  margin: 0 0 0.25rem 0;\r\n}\r\n.dv-error-item:last-child { margin-bottom: 0; }\r\n\r\n/* ── Sidebar notes (chatter lite) ── */\r\n.dv-sidebar-title {\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  color: var(--text-muted);\r\n  padding: 0.85rem 1rem 0.5rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.dv-note-input-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.dv-note-btn { align-self: flex-end; }\r\n.dv-notes-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 0.75rem 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.85rem;\r\n}\r\n.dv-empty-notes { font-size: 0.8rem; color: var(--text-muted); text-align: center; margin: 1rem 0; }\r\n.dv-note-item { display: flex; flex-direction: column; gap: 4px; }\r\n.dv-note-header { display: flex; align-items: center; gap: 8px; }\r\n.dv-note-avatar {\r\n  width: 26px; height: 26px; border-radius: 50%;\r\n  background: linear-gradient(135deg, var(--accent-dark), var(--accent));\r\n  display: flex; align-items: center; justify-content: center;\r\n  color: #fff; font-size: 0.6rem; font-weight: 700; flex-shrink: 0;\r\n}\r\n.dv-note-who { font-size: 0.78rem; font-weight: 600; color: var(--text-primary); }\r\n.dv-note-when { font-size: 0.72rem; color: var(--text-muted); }\r\n.dv-note-text { font-size: 0.8rem; color: var(--text-secondary); line-height: 1.4; margin: 0; }\r\n\r\n/* ── VM detail polish ───────────────────────────────────────────────────── */\r\n.dv-col-span-all { grid-column: 1 / -1; }\r\n\r\n.dv-smart-btn-agent {\r\n  border-color: rgba(var(--accent-rgb), 0.28) !important;\r\n}\r\n\r\n.vm-agent-inline-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n  flex-wrap: wrap;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 0.6rem 0.75rem;\r\n}\r\n\r\n.vm-badge {\r\n  border-radius: 999px;\r\n  padding: 0.22rem 0.55rem;\r\n  font-size: 0.73rem;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n\r\n.vm-guest-chip {\r\n  font-size: 0.76rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.vm-meta-pill {\r\n  font-size: 0.72rem;\r\n  color: var(--text-secondary);\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  padding: 0.16rem 0.45rem;\r\n}\r\n\r\n.vm-meta-mono {\r\n  font-family: var(--font-mono);\r\n}\r\n\r\n.vm-checkbox-row {\r\n  display: flex;\r\n  gap: 1.3rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.vm-checkbox-item {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.vm-agent-stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\r\n  gap: 0.45rem;\r\n  background: color-mix(in oklab, var(--accent) 7%, var(--bg-card));\r\n  border: 1px solid color-mix(in oklab, var(--accent) 28%, var(--border));\r\n  border-radius: 10px;\r\n  padding: 0.65rem 0.75rem;\r\n  font-size: 0.77rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.vm-readonly-banner {\r\n  margin-bottom: 0.75rem;\r\n  padding: 0.62rem 0.75rem;\r\n  border-radius: 8px;\r\n  font-size: 0.78rem;\r\n  border: 1px solid color-mix(in oklab, var(--accent) 30%, var(--border));\r\n  background: color-mix(in oklab, var(--accent) 8%, var(--bg-card));\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.vm-data-table {\r\n  width: 100%;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  font-size: 0.81rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  background: var(--bg-card);\r\n}\r\n\r\n.vm-data-table th,\r\n.vm-data-table td {\r\n  text-align: left;\r\n  padding: 0.5rem 0.6rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.vm-data-table th {\r\n  font-weight: 700;\r\n  font-size: 0.72rem;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.vm-data-table tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.vm-data-table tbody tr:hover td {\r\n  background: rgba(var(--accent-rgb), 0.06);\r\n}\r\n\r\n.vm-input-compact {\r\n  padding: 0.3rem 0.45rem;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.vm-input-xs {\r\n  width: 5rem;\r\n}\r\n\r\n.vm-icon-btn {\r\n  background: transparent;\r\n  border: 1px solid var(--border);\r\n  color: var(--text-secondary);\r\n  border-radius: 6px;\r\n  width: 1.8rem;\r\n  height: 1.8rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.vm-icon-btn:hover {\r\n  color: var(--text-primary);\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.vm-icon-btn-primary {\r\n  color: var(--accent);\r\n}\r\n\r\n.vm-icon-btn-danger {\r\n  color: #ef4444;\r\n}\r\n\r\n.vm-dashed-btn {\r\n  margin-top: 0.75rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  background: transparent;\r\n  border: 1px dashed var(--border);\r\n  border-radius: 8px;\r\n  padding: 0.4rem 0.75rem;\r\n  color: var(--text-secondary);\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.vm-dashed-btn:hover {\r\n  border-color: var(--accent);\r\n  color: var(--accent-l);\r\n  background: rgba(var(--accent-rgb), 0.06);\r\n}\r\n\r\n.vm-inline-actions {\r\n  display: inline-flex;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.vm-nic-name-cell {\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.vm-nic-type-wrap {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.vm-nic-type-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.22rem;\r\n  border-radius: 999px;\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  padding: 0.1rem 0.4rem;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.vm-nic-tone-accent {\r\n  background: rgba(var(--accent-rgb), 0.14);\r\n  color: var(--accent-l);\r\n  border-color: rgba(var(--accent-rgb), 0.32);\r\n}\r\n\r\n.vm-nic-tone-cyan {\r\n  background: rgba(14, 165, 233, 0.14);\r\n  color: #0ea5e9;\r\n  border-color: rgba(14, 165, 233, 0.32);\r\n}\r\n\r\n.vm-nic-tone-blue {\r\n  background: rgba(59, 130, 246, 0.14);\r\n  color: #3b82f6;\r\n  border-color: rgba(59, 130, 246, 0.32);\r\n}\r\n\r\n.vm-nic-tone-neutral {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  border-color: var(--border);\r\n}\r\n\r\n.vm-nic-status {\r\n  font-size: 0.65rem;\r\n  font-weight: 700;\r\n  border-radius: 999px;\r\n  padding: 0.08rem 0.35rem;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.vm-nic-status-ok {\r\n  color: #10b981;\r\n  background: rgba(16, 185, 129, 0.14);\r\n  border-color: rgba(16, 185, 129, 0.3);\r\n}\r\n\r\n.vm-nic-status-warn {\r\n  color: #f59e0b;\r\n  background: rgba(245, 158, 11, 0.14);\r\n  border-color: rgba(245, 158, 11, 0.3);\r\n}\r\n\r\n.vm-nic-status-muted {\r\n  color: var(--text-muted);\r\n  background: var(--bg-toolbar);\r\n  border-color: var(--border);\r\n}\r\n\r\n.vm-mini-tag {\r\n  margin-left: 0.35rem;\r\n  font-size: 0.62rem;\r\n  border-radius: 999px;\r\n  padding: 0.06rem 0.4rem;\r\n  background: rgba(16, 185, 129, 0.14);\r\n  color: #10b981;\r\n  font-weight: 700;\r\n}\r\n\r\n.vm-cell-mono {\r\n  font-family: var(--font-mono);\r\n}\r\n\r\n.vm-cell-muted {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.vm-cell-subtle {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.vm-cell-ip {\r\n  color: var(--accent-l);\r\n}\r\n\r\n.vm-stack-inline {\r\n  display: inline-flex;\r\n  gap: 0.35rem;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.vm-nic-pg-name {\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.vm-nic-vlan-chip {\r\n  border-radius: 999px;\r\n  padding: 0.06rem 0.4rem;\r\n  font-size: 0.66rem;\r\n  background: rgba(var(--accent-rgb), 0.14);\r\n  color: var(--accent-l);\r\n  font-family: var(--font-mono);\r\n}\r\n\r\n.vm-nic-vswitch {\r\n  font-size: 0.7rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.vm-empty-inline {\r\n  font-style: italic;\r\n  color: var(--text-muted);\r\n  font-size: 0.76rem;\r\n}\r\n\r\n.vm-inventory-grid {\r\n  display: grid;\r\n  gap: 0.95rem;\r\n}\r\n\r\n.vm-kpi-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\r\n  gap: 0.55rem;\r\n}\r\n\r\n.vm-kpi-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: linear-gradient(180deg, color-mix(in oklab, var(--bg-card) 86%, var(--accent) 14%), var(--bg-card));\r\n  padding: 0.52rem 0.6rem;\r\n  opacity: 0;\r\n  transform: translateY(6px) scale(0.985);\r\n  animation: vm-kpi-in 320ms cubic-bezier(0.2, 0.7, 0, 1) forwards;\r\n  animation-delay: var(--kpi-delay, 0ms);\r\n  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;\r\n}\r\n\r\n.vm-kpi-card:hover {\r\n  transform: translateY(-1px);\r\n  border-color: color-mix(in oklab, var(--accent) 40%, var(--border));\r\n  box-shadow: 0 8px 18px rgba(var(--accent-rgb), 0.16);\r\n}\r\n\r\n@keyframes vm-kpi-in {\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n.vm-kpi-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.32rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.vm-kpi-icon {\r\n  width: 1.1rem;\r\n  height: 1.1rem;\r\n  border-radius: 999px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--accent-l);\r\n  background: rgba(var(--accent-rgb), 0.14);\r\n}\r\n\r\n.vm-kpi-label {\r\n  font-size: 0.68rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  font-weight: 700;\r\n}\r\n\r\n.vm-kpi-value {\r\n  margin-top: 0.22rem;\r\n  font-size: 1.05rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.vm-inventory-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n  padding: 0.85rem;\r\n}\r\n\r\n.vm-inventory-title {\r\n  font-size: 0.82rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.55rem;\r\n}\r\n\r\n.vm-table-toolbar {\r\n  margin-bottom: 0.45rem;\r\n}\r\n\r\n.vm-table-scroll {\r\n  max-height: 240px;\r\n  overflow: auto;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n}\r\n\r\n.vm-compact-table {\r\n  width: 100%;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  background: var(--bg-card);\r\n  font-size: 0.76rem;\r\n}\r\n\r\n.vm-compact-table th,\r\n.vm-compact-table td {\r\n  text-align: left;\r\n  padding: 0.38rem 0.48rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.vm-compact-table th {\r\n  font-size: 0.67rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--text-muted);\r\n  background: var(--bg-toolbar);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n  user-select: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.vm-compact-table tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.vm-compact-table tbody tr:hover td {\r\n  background: rgba(var(--accent-rgb), 0.06);\r\n}\r\n\r\n.vm-mt-md {\r\n  margin-top: 0.85rem;\r\n}\r\n\r\n.vm-empty-note {\r\n  font-size: 0.76rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.vm-chip-list {\r\n  display: flex;\r\n  gap: 0.4rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.vm-chip {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  padding: 0.18rem 0.5rem;\r\n  font-size: 0.72rem;\r\n  font-family: var(--font-mono);\r\n}\r\n\r\n.vm-chip.is-primary {\r\n  background: rgba(var(--accent-rgb), 0.14);\r\n  color: var(--accent-l);\r\n  border-color: rgba(var(--accent-rgb), 0.3);\r\n}\r\n\r\n.vm-inventory-list {\r\n  display: grid;\r\n  gap: 0.38rem;\r\n}\r\n\r\n.vm-inventory-list-spaced {\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.vm-inventory-scroll {\r\n  max-height: 220px;\r\n  overflow: auto;\r\n  padding-right: 0.35rem;\r\n}\r\n\r\n.vm-row-text {\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.35;\r\n}\r\n\r\n.vm-row-meta {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.vm-row-meta-muted {\r\n  opacity: 0.92;\r\n}\r\n\r\n.vm-agent-modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1060;\r\n  background: rgba(2, 6, 23, 0.62);\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 1rem;\r\n}\r\n\r\n.vm-agent-modal {\r\n  width: min(760px, 96vw);\r\n  border-radius: 14px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-surface);\r\n  box-shadow: 0 24px 48px rgba(2, 6, 23, 0.35);\r\n  color: var(--text-primary);\r\n  padding: 1rem;\r\n}\r\n\r\n.vm-agent-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n  margin-bottom: 0.85rem;\r\n}\r\n\r\n.vm-agent-modal-header h4 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.vm-agent-modal-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 0.65rem;\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .vm-agent-modal-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.vm-agent-modal-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: var(--slate-100);\r\n  padding: 0.65rem 0.7rem;\r\n}\r\n\r\n.vm-agent-modal-label {\r\n  font-size: 0.68rem;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  margin-bottom: 0.3rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.vm-agent-modal-main {\r\n  font-size: 0.83rem;\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.vm-agent-modal-help {\r\n  margin-top: 0.35rem;\r\n  font-size: 0.73rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.35;\r\n}\r\n\r\n.vm-agent-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.5rem;\r\n  margin-top: 0.9rem;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   MÓVIL — la ficha a pantalla completa\r\n   ───────────────────────────────────────────────────────────────────────────\r\n   El panel de actividad mide 320 px fijos: en un móvil de 390 dejaba al\r\n   formulario con 70 px (se veía una tira vertical). Aquí el formulario ocupa\r\n   todo el ancho y todo el alto; el panel de actividad flota encima cuando se\r\n   abre desde su pestaña. El topbar se desplaza en horizontal porque los\r\n   botones con texto no caben. El bloque va AL FINAL a propósito: así gana a\r\n   las declaraciones base de `.dv-topbar`, `.dv-sidebar` y `.dv-activity-rail`.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n@media (max-width: 768px) {\r\n  .dv-topbar {\r\n    padding: 0 0.5rem;\r\n    gap: 0.4rem;\r\n    overflow-x: auto;\r\n    scrollbar-width: none;\r\n  }\r\n\r\n  .dv-topbar::-webkit-scrollbar { display: none; }\r\n  .dv-topbar > * { flex-shrink: 0; }\r\n  .dv-breadcrumb,\r\n  .dv-topbar-sep { display: none; }\r\n  .dv-topbar-spacer { flex: 1 0 8px; }\r\n\r\n  .dv-btn {\r\n    padding: 0.3rem 0.6rem;\r\n    font-size: 0.78rem;\r\n  }\r\n\r\n  .dv-body {\r\n    flex-direction: column;\r\n    position: relative;\r\n  }\r\n\r\n  .dv-main {\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    padding: 1rem;\r\n  }\r\n\r\n  .dv-main.sf2-main { padding: 0; }\r\n\r\n  /* Abierto: hoja inferior que flota sobre el formulario (no reparte altura). */\r\n  .dv-sidebar.dv-activity {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    width: auto;\r\n    max-height: 55dvh;\r\n    z-index: 30;\r\n    border-left: 0;\r\n    border-top: 1px solid var(--border);\r\n    border-radius: 14px 14px 0 0;\r\n    box-shadow: 0 -10px 28px rgba(0, 0, 0, 0.28);\r\n  }\r\n\r\n  /* Plegado: pestaña flotante abajo a la derecha. */\r\n  .dv-activity-rail {\r\n    position: absolute;\r\n    right: 0.6rem;\r\n    bottom: 0.6rem;\r\n    width: max-content;\r\n    height: 36px;\r\n    flex-direction: row;\r\n    padding: 0 14px;\r\n    gap: 6px;\r\n    z-index: 20;\r\n    border: 1px solid var(--border);\r\n    border-left: 1px solid var(--border);\r\n    border-radius: 999px;\r\n    background: var(--bg-surface, var(--bg-card));\r\n    box-shadow: var(--shadow-md);\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .dv-activity-rail span { white-space: nowrap; }\r\n\r\n  .dv-record-title { font-size: 1.35rem; }\r\n}\r\n\r\n/* A 390 px el texto «Actividad» no cabe junto al icono y se partía letra a\r\n   letra. Se queda el icono; el `title` del botón ya lo explica. */\r\n@media (max-width: 480px) {\r\n  .dv-activity-rail {\r\n    width: 40px;\r\n    padding: 0;\r\n    justify-content: center;\r\n  }\r\n\r\n  .dv-activity-rail span { display: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
